<div class="loader-overlay">
  <div class="loader-content text-center">
    <div class="spinner-border text-primary" role="status">
      <!-- <span class="visually-hidden">Loading...</span> -->
    </div>
    <div class="mt-3 loader-message">
      {{ message }}  <span class="dot-typing"></span>
    </div>
  </div>
</div>
